import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlarmDataService {
setAlarm(data: any) {
    sessionStorage.setItem('alarmDetailsData', JSON.stringify(data));
  }

  getAlarm() {
    const data = sessionStorage.getItem('alarmDetailsData');
    return data ? JSON.parse(data) : null;
  }

  clearAlarm() {
    sessionStorage.removeItem('alarmDetailsData');
  }

   private activeCountSource = new BehaviorSubject<number>(0);
  activeCount$ = this.activeCountSource.asObservable();

  setActiveCount(count: number) {
    this.activeCountSource.next(count);
  }

   sidebarState$ = new BehaviorSubject<boolean>(false);
   disableSidebar$ = new BehaviorSubject<boolean>(true);

  toggle(state: boolean) {
    this.sidebarState$.next(state);
  }
}
